module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-005"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "chap1",
      "src": "images/chap1.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("WHERE ARE YOU FROM?")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-003_1",
      "src": "images/DINGBAT_art.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("I’VE ALWAYS BEEN FASCINATED")]), _vm._v(" by Jesus’ statement of homelessness in Luke 9:58, where he says, “Foxes have dens and birds have nests, but the Son of Man has no place to lay his head.” Perhaps Jesus is inviting us to find home within. If we can be at home anywhere, we can be at home everywhere.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’ve actually been searching for home all my life. I was born in Saskatoon, Saskatchewan, and by the time I was twenty-five, “home” had been eight different cities. Then I landed in Austin, Texas, and I’ve been here for twenty years now.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the end of a recent eight-week jaunt around the country, my family cheered when we pulled our camper onto our street. We hugged and high-fived. We were hugging and high-fiving for a sense of home. For the neighbors we’ve seen grow up and move off to college. For the coffee shop, bar, and restaurant owners who built this neighborhood together with us. For our friends and acquaintances. Whoops and hollers. We were finally home.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Occasionally, however, I am reminded that I’m still not "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("completely at home in Austin. This happens to me about once a year.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A few months ago I was sitting at a bodega in my neighborhood called Quickie Pickie. I was enjoying a Topo Chico while finishing some work at a table on the patio. I noticed in my peripheral vision a man staring at me. After a few minutes he was still staring, so I glanced over and we made eye contact. I smiled and looked back at my MacBook. Another few minutes and he was still looking at me, so I smiled and waved. He took that as a sign to get up and come over to my table. He introduced himself as Gary and asked me the question all people of color love to be asked: “Where are you from?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("With an internal eye roll I responded, “I’ve lived in Austin for twenty years. I think I can say Austin is home.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Where are you from, though?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Well, I moved here from Detroit.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“I mean, where are you "), _c('i', [_vm._v("really")]), _vm._v(" from?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“I lived in Chicago before that.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Seriously, where are you "), _c('i', [_vm._v("from")]), _vm._v(" from?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“OK, you got me. I’m from Canada.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He then proceeded to tell me a long story about his trip to Japan and his Japanese friend. I listened to his entire way-too-long story because I’m polite and Canadian. At the end I said, “Cool story. I’m not Japanese and I’ve never been to Japan.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He walked away confused.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("As a Seven who’s done chasing and moving, I’ve continued to ask questions about home. I’ve realized that as I’ve moved and traveled around the world, I’ve been running from asking myself who I am. Sevens will visit any other place rather than be at home with themselves.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So what "), _c('i', [_vm._v("does")]), _vm._v(" it mean to be at home with myself? For me it means exploring underlying questions such as: What does it look like for a Chinese Canadian to be at home in Austin? When did I start to assimilate and externalize my sense of home? What’s the appropriate amount of space for a Chinese Canadian man to take up in the world? Why do I apologize so compulsively—am I apologizing for my existence? How can I be at home with the paradox that I’m not that important "), _c('i', [_vm._v("and")]), _vm._v(" I am the glory of God?")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-001"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("What does it mean for you to be home with yourself?")])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "response"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("What other questions emerge as you consider that question?")])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "response"
    }
  })])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 72
// module chunks = 0